import "./style.scss";
import gsap from "gsap";

if (document.querySelector(".marquee")) {
	const marquees = document.querySelectorAll(".marquee");

	marquees.forEach(function (marquee) {

		let div_width = 0;

		marquee.querySelectorAll("div").forEach(function (div) {
			for ( var i=0; i < (Math.ceil(( window.innerWidth * 2) / div.getBoundingClientRect().width) - 1); i++ ) {
				let clone = div.cloneNode(true);
				marquee.append(clone);
			}
			div_width = div.getBoundingClientRect().width;
		});

		let duration = 30;
		gsap.set(marquee, { x: marquee.classList.contains("reverse") ? -div_width : 0, });
		var tl = gsap.timeline();
		tl.to(marquee, {
			ease: "none",
			duration: marquee.dataset.duration ? marquee.dataset.duration : duration,
			x: marquee.classList.contains("reverse") ? 0 : -div_width,
			repeat: -1,
		});

	});
}